<template>
  <el-card
    shadow="hover"
    style="min-height: 200px"
    v-loading="loading || treeLoading"
  >
    <div style="padding: 10px 20px">
      <div v-if="editModel && treeData">
        <el-form
          ref="form"
          :model="editModel"
          :rules="editRules"
          :size="$xUISize"
          label-width="auto"
          label-position="top"
          @submit.native.prevent
        >
          <el-form-item label="请勾选账号门店权限" prop="extras">
            <div
              :key="'store-group-' + group.info.guid"
              style="margin-bottom: 5px"
              v-for="group in groupList"
            >
              <div>
                <span style="color: #919191">
                  {{ group.info.name }}
                </span>
              </div>
              <el-tree
                show-checkbox
                node-key="guid"
                :ref="'tree-' + group.info.guid"
                :data="group.childrenList"
                :check-on-click-node="true"
                :default-expanded-keys="editModel.extras"
                :default-checked-keys="editModel.extras"
                @check-change="handleTreeChange"
                v-model="editModel.extras"
              >
              </el-tree>
            </div>
          </el-form-item>
          <el-form-item v-if="treeData">
            <el-button
              type="primary"
              :loading="editSubmit"
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<style lang="less" >
.el-tree-node__content {
  height: 40px;

  .el-checkbox {
    font-size: 22px;
    margin-left: -10px;
  }

  .el-tree-node__label {
    font-size: 16px;
  }
}
</style>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
    groupList() {
      let storehouseData = {};
      (this.treeData || []).forEach(tree => {
        if (tree.storeInfo && tree.storeInfo.optStorehouse == 1) {
          storehouseData[tree.storeInfo.guid] = {
            info: tree.storeInfo,
            childrenList: [tree]
          }
        }
      });
      (this.treeData || []).forEach(tree => {
        if (tree.storeInfo && tree.storeInfo.storehouseInfo) {
          if (storehouseData[tree.storeInfo.storehouseGuid]) {
            storehouseData[tree.storeInfo.storehouseGuid]
              .childrenList.push(tree);
          } else {
            storehouseData[tree.storeInfo.storehouseGuid] = {
              info: tree.storeInfo,
              childrenList: [tree]
            }
          }
        }
      });
      return Object.values(storehouseData);
    }
  },
  data() {
    return {
      treeErrorMsg: null,
      treeLoading: false,
      treeData: null,
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {},
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi("biz.customer.account.info.update", this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      let extras = [];
      try {
        extras = JSON.parse(this.editModel.extras)
      } catch (e) {
      }
      this.editModel.extras = extras;
    },
    handleTreeChange() {
      if (!this.editModel) {
        return;
      }
      this.editModel.extras = [];
      (this.groupList || []).forEach(group => {
        let ref = this.$refs['tree-' + group.info.guid];
        if (ref instanceof Array && ref.length > 0) {
          ref.forEach(refComp => {
            this.editModel.extras.push(...refComp.getCheckedKeys().filter((item) => {
              return !!item
            }))
          });
        } else if (ref) {
          this.editModel.extras.push(...ref.getCheckedKeys().filter((item) => {
            return !!item
          }))
        }
      });
    },
    fetchStoreList() {
      // 编辑
      this.treeErrorMsg = null;
      this.treeLoading = true;
      this.requestApi("biz.customer.store.info.list", {
        customerGuid: this.editModel.customerGuid
      }).then((resp) => {
        this.treeData = (resp.data.list || []).map(store => {
          return {
            label: store.name,
            guid: store.guid,
            storeInfo: store
          }
        });
      }).catch((err) => {
        this.treeErrorMsg = (err && err.msg) || "连接服务器失败，请检查网络";
      }).finally(() => {
        this.treeLoading = false;
      });
    },
    fetchModel() {
      // 编辑
      this.errorMsg = null;
      this.loading = true;
      this.requestApi("biz.customer.account.info.detail", {
        guid: this.pageParams.guid,
      }).then((resp) => {
        this.loading = false;
        this.editModel = resp.data;
        this.handleModel();
        this.fetchStoreList();
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && err.msg) || "连接服务器失败，请检查网络";
      });
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
